import React from 'react';

import { PanelResizeHandle } from 'react-resizable-panels';

import styles from './resizable-handle.module.scss';

interface Props {
	disabled?: boolean;
}

const ResizableHandle = ({ disabled }: Props) => (
	<PanelResizeHandle className={styles.resizeHandle} disabled={disabled}>
		<div className={styles.resizeHandleInner} />
	</PanelResizeHandle>
);

export default ResizableHandle;
